import { render } from "./Notificaciones.vue?vue&type=template&id=007c30d5&scoped=true&ts=true"
import script from "./Notificaciones.vue?vue&type=script&lang=ts"
export * from "./Notificaciones.vue?vue&type=script&lang=ts"

import "./Notificaciones.vue?vue&type=style&index=0&id=007c30d5&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007c30d5"]])

export default __exports__